import EsusView from 'components/esus/EsusView'

export default function FichaVisitaDomiciliarView() {
  return <EsusView url='/pec/user/cds/visitaDomiciliar' />
}
